import { HttpErrorResponse } from '@angular/common/http';
import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import { PeppolMessageDetail } from '../../../interfaces/peppol-detail.interface';
import { PeppolRejectRequest } from '../../../interfaces/peppol-item.dto';
import { PeppolAction } from '../../../interfaces/peppol-action.interface';

export const peppolDetailPageEvents = eventGroup({
  source: 'Peppol Detail Page',
  events: {
    initialized: type<{ messageId: string }>(),
    fileViewed: type<{ name: string }>(),
    attachmentRequested: type<{ name: string }>(),
    downloadRequested: type<{ name: string }>(),
    statusActionConfirmed: type<{ action: PeppolAction }>(),
    rejectConfirmed: type<{ request: PeppolRejectRequest }>(),
  },
});

export const peppolDetailApiEvents = eventGroup({
  source: 'Peppol Detail API',
  events: {
    detailLoaded: type<PeppolMessageDetail>(),
    detailReloaded: type<PeppolMessageDetail>(),
    detailLoadFailed: type<{ error: HttpErrorResponse | Error }>(),
    detailReloadFailed: type<{ error: HttpErrorResponse | Error }>(),
    attachmentContentLoaded: type<{ name: string; content: string }>(),
    attachmentContentFailed: type<{ name: string; error: HttpErrorResponse }>(),
    actionSucceeded: type<{ action: PeppolAction }>(),
    actionFailed: type<{ action: PeppolAction; error: HttpErrorResponse }>(),
  },
});
